export const exportData = (filename, data) => {
    const jsonString = `data:text/csv;chatset=utf-8,${encodeURIComponent(data)}`;
    const link = document.createElement("a");
    link.href = jsonString;
    link.download = `${filename}.csv`;

    link.click();
};